import { render, staticRenderFns } from "./chat-session-card.vue?vue&type=template&id=4ae6e869&scoped=true"
import script from "./chat-session-card.vue?vue&type=script&lang=js"
export * from "./chat-session-card.vue?vue&type=script&lang=js"
import style0 from "./chat-session-card.vue?vue&type=style&index=0&id=4ae6e869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae6e869",
  null
  
)

export default component.exports